import React from 'react';
import { Button, SxProps, Theme } from '@mui/material';

interface ActionButtonProps {
  text: string;
  onClick?: () => void;
  href?: string;
  startIcon?: React.ReactNode;
  color?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export function ActionButton({
  text,
  onClick,
  href,
  startIcon,
  color = '#4A90E2',
  disabled = false,
  sx = {},
}: ActionButtonProps) {
  const baseStyles: SxProps<Theme> = {
    border: `1px solid ${color}`,
    borderRadius: '12px',
    color: color,
    textTransform: 'none',
    px: 1.5,
    py: 0.75,
    fontSize: 13,
    '&:hover': {
      border: `1px solid ${color}`,
      backgroundColor: `${color}14`,
    },
    '&:disabled': {
      opacity: 0.5,
    },
    ...sx,
  };

  if (href) {
    return (
      <Button
        size="small"
        variant="outlined"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        sx={baseStyles}
        startIcon={startIcon}
        disabled={disabled}
      >
        {text}
      </Button>
    );
  }

  return (
    <Button
      size="small"
      variant="outlined"
      onClick={onClick}
      sx={baseStyles}
      startIcon={startIcon}
      disabled={disabled}
    >
      {text}
    </Button>
  );
}

